import { SideBarTypes } from '../../constants';
import { SidebarParams } from '../../interface';

export const key = 'sidebar';

export type SidebarType = {
	sideBarType: SideBarTypes | undefined;
	params: SidebarParams | undefined;
	isOpen: boolean;
};

export type GlobalStore = {
	[key]: SidebarType;
};

export const initialState: SidebarType = {
	sideBarType: undefined,
	params: undefined,
	isOpen: false,
};
